"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneOptions = exports.DEFAULT_TIMEZONE = exports.initialNotificationValues = exports.EVENT_TOPICS = exports.currenciesOptions = void 0;
exports.currenciesOptions = [
    { value: "R", label: "🇿🇦 ZAR" },
    { value: "$", label: "🇺🇸 USD" },
    { value: "€", label: "🇪🇺 EUR" },
    { value: "₹", label: "🇮🇳 INR" },
    { value: "£", label: "🇬🇧 GBP" },
    { value: "¢", label: "🇬🇭 GHS" },
    { value: "Rp", label: "🇮🇩 IDR" },
    { value: "J$", label: "🇯🇲 JMD" },
    { value: "¥", label: "🇯🇵 JPY" },
    { value: "ден", label: "🇲🇰 MKD" },
    { value: "₱", label: "🇵🇭 PHP" },
    { value: "zł", label: "🇵🇱 PLN" },
    { value: "RM", label: "🇲🇾 MYR" },
    { value: "₽", label: "🇷🇺 RUB" },
    { value: "S$", label: "🇸🇬 SGD" },
    { value: "CHF", label: "🇨🇭 CHF" },
    { value: "NT$", label: "🇹🇼 TWD" },
    { value: "฿", label: "🇹🇭 THB" },
    { value: "₺", label: "🇹🇷 TRY" },
    { value: "AED", label: "🇦🇪 AED" },
    { value: "₴", label: "🇺🇦 UAH" },
    { value: "₫", label: "🇻🇳 VND" },
];
// Please note the root keys (and prefix for topic) are the model name as seen in mongodb
exports.EVENT_TOPICS = {
    users: {
        CREATED: "users/created",
        UPDATED: "users/updated",
    },
    baskets: {
        CREATED: "baskets/created",
        UPDATED: "baskets/updated",
    },
    orders: {
        CREATED: "orders/created",
        VIEWED: "orders/viewed",
        UPDATED: "orders/updated",
        STATUS_CHANGE: "orders/status-change",
    },
    parcels: {
        CREATED: "parcels/created",
        PACKED: "parcels/packed",
        FULFILLED: "parcels/fulfilled",
        UPDATED: "parcels/updated",
        STATUS_CHANGE: "parcels/status-change",
    },
    loyaltyprograms: {
        CREATED: "loyaltyprograms/created",
        UPDATED: "loyaltyprograms/updated",
    },
};
exports.initialNotificationValues = { enabled: false, returns_email_address: "" };
exports.DEFAULT_TIMEZONE = "Africa/Johannesburg";
// Full IANA timezone list sourced from the browser's Intl API.
// Falls back to a minimal set on the (rare) runtime without
// Intl.supportedValuesOf — every evergreen browser has had it since 2022.
var getTimezoneOptions = function () {
    var intl = Intl;
    if (typeof intl.supportedValuesOf === "function") {
        return intl.supportedValuesOf("timeZone");
    }
    return [exports.DEFAULT_TIMEZONE, "UTC"];
};
exports.getTimezoneOptions = getTimezoneOptions;
